import { render, staticRenderFns } from "./PersonStep2.vue?vue&type=template&id=19c88872&scoped=true&"
import script from "./PersonStep2.vue?vue&type=script&lang=js&"
export * from "./PersonStep2.vue?vue&type=script&lang=js&"
import style0 from "./PersonStep2.vue?vue&type=style&index=0&id=19c88872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c88872",
  null
  
)

export default component.exports